import { render, staticRenderFns } from "./ResHost.vue?vue&type=template&id=0b4318a1&scoped=true"
import script from "./ResHost.vue?vue&type=script&lang=js"
export * from "./ResHost.vue?vue&type=script&lang=js"
import style0 from "./ResHost.vue?vue&type=style&index=0&id=0b4318a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4318a1",
  null
  
)

export default component.exports